module.exports = __webpack_public_path__ + "static/assets/3a4e5b9018c9a71f37fbe1839ab85030.svg";